<template>
    <v-container>
        <v-row>
            <v-col>
                <div class="headline">Kalender</div>

                <div class="d-flex align-center">
                    <div :class="[{'d-flex': $vuetify.breakpoint.lgAndUp ? true:false}, 'align-center']">
                        <div>
                            uke #{{date.format('w')}}, {{date.format('MMM')}} {{date.format('YYYY')}}
                        </div>
                        <div v-if="$vuetify.breakpoint.lgAndUp" class="mx-3"></div>
                        <v-checkbox v-model="showSiteplan" label="vis riggplan" color="primary" hide-details="true" class="ma-0 pa-0"></v-checkbox>
                    </div>

                    <v-spacer></v-spacer>
                    <v-btn @click="previousWeek" color="primary" class="mx-1" :small="$vuetify.breakpoint.smAndDown">
                        <v-icon :left="$vuetify.breakpoint.lgAndUp">mdi-chevron-left</v-icon>
                        <span v-if="$vuetify.breakpoint.lgAndUp">forrige uke</span>
                    </v-btn>
                    <v-btn @click="today" color="primary" class="mx-1" :small="$vuetify.breakpoint.smAndDown">
                        <v-icon :left="$vuetify.breakpoint.lgAndUp">mdi-calendar-today</v-icon>
                        <span v-if="$vuetify.breakpoint.lgAndUp">i dag</span>
                    </v-btn>
                    <v-btn @click="nextWeek" color="primary" class="mx-1" :small="$vuetify.breakpoint.smAndDown">
                        <span v-if="$vuetify.breakpoint.lgAndUp">neste uke</span>
                        <v-icon :right="$vuetify.breakpoint.lgAndUp">mdi-chevron-right</v-icon>
                    </v-btn>
                </div>

                <br>

                <v-row>
                    <v-col cols="12" :lg="showSiteplan? 8 : 12">
                        <div class="elevation-1">
                            <v-calendar ref="cal" :events="events" @mouseenter:event="eventMouseEnter" @mouseleave:event="eventMouseLeave" @click:event="eventClicked" :start="date.format('YYYY-MM-DD')" :max-days="5" :type="calendarType" :weekdays="calendar.weekdays" :weekday-format="calendar.weekdayFormat" :interval-format="calendar.intervalFormat" :event-overlap-mode="calendar.overlapMode" :event-overlap-threshold="calendar.overlapThreshold" :event-color="eventColor" color="primary" style="height: 720px">
                                <template v-slot:event="{event}">
                                    <div class="d-flex" :style="{'background': 'transparent'}">
                                        <div class="d-flex">
                                            <v-icon v-if="event.delivery && event.delivery.inAccessCode && event.delivery.inAccessCode.claims> 0" x-small dark>mdi-check-circle</v-icon>
                                            <div class="ml-1"></div>
                                            <div>{{event.delivery.name}}</div>
                                        </div>
                                        <v-icon v-if="event.delivery.resources && event.delivery.resources.length > 0" small class="ml-2">mdi-wrench</v-icon>
                                    </div>
                                </template>
                            </v-calendar>
                        </div>
                    </v-col>
                    <v-col v-if="showSiteplan" cols="12" lg="4">
                        <!-- <h2>Riggplan</h2> -->

                        <div style="cursor: pointer;">
                            <v-carousel>
                                <v-carousel-item v-for="siteplan in siteplans" :key="siteplan">

                                    <v-progress-linear v-if="!siteplan.src" indeterminate></v-progress-linear>
                                    <v-img v-if="/^data:image\/.*/.test(siteplan.src) && !!siteplan.src" :src="siteplan.src" contain height="100%" width="100%" @click.stop="() => {content = siteplan; contentShow = true;}"></v-img>

                                    <iframe v-if="/^data:application\/pdf.*/.test(siteplan.src) && !!siteplan.src" :src="`${siteplan.url}#view=fit&toolbar=0`" allowfullscreen="true" height="100%" width="100%" style="height: -webkit-fill-available; width: -webkit-fill-available; padding: 0px; margin: 0px; border: none;"></iframe>

                                </v-carousel-item>
                            </v-carousel>
                        </div>
                    </v-col>
                </v-row>

            </v-col>
        </v-row>

        <v-dialog v-model="contentShow" @keydown.esc="() => {contentShow = false; contentFullscreen = false;}">
            <div v-if="content && content.name" style="max-height: 90vmin; background: white; position: relative;">
                <div style="position: absolute; background: rgba(255,255,255,0.65); z-index: 10;" class="ma-2 pa-2 text-h6">{{/.*\/.*\/(.*)/.exec(content.name)[1]}}</div>
                <div style="position: absolute; top: 10px; right: 10px; z-index: 10; display: flex; flex-direcion: row;">
                    <v-btn fab small color="rgba(255,255,255,0.65)" style="position: sticky;" @click="() => {contentFullscreen = !contentFullscreen;}">
                        <v-icon v-if="contentFullscreen">mdi-fullscreen-exit</v-icon>
                        <v-icon v-else>mdi-fullscreen</v-icon>
                    </v-btn>
                    <div class="mx-1"></div>
                    <v-btn fab small color="rgba(255,255,255,0.65)" style="position: sticky;" @click="() => { contentShow = false; contentFullscreen = false;}">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>

                <v-img v-if="!contentFullscreen" :src="content.src" class="ma-auto" max-height="90vmin" max-width="90vmin" :contain="!contentFullscreen"></v-img>
                <v-img v-else :src="content.src" class="ma-auto"></v-img>

            </div>
        </v-dialog>

        <v-dialog v-model="eventDialog.show" :max-width="$vuetify.breakpoint.smAndDown ? '100%' : '50%'" :overlay-color="snackbar.color">
            <v-card @click="openEvent">
                <v-card-title :style="{'background': 'lightgrey'}">
                    <div style="width: 100%;">
                        <div class="d-flex align-center">
                            <div>{{snackbar && snackbar.data && snackbar.data.delivery ? snackbar.data.delivery.name : ''}}</div>
                            <v-spacer></v-spacer>
                            <v-btn @click.stop="eventDialog.show = false" color="grey " x-small>
                                <!-- <v-icon left x-small>mdi-close</v-icon> -->
                                steng
                            </v-btn>
                        </div>
                        <div class="text-subtitle-2">Klikk på dialog får å åpne leveranse</div>
                    </div>
                </v-card-title>
                <v-card-text>
                    <div v-if="snackbar.data" style="width: 100%;">
                        <!-- <div class="d-flex flex-row">
                            <div>Emne:</div>
                            <v-spacer></v-spacer>
                            <div>{{snackbar.data.delivery.name}}</div>
                        </div> -->
                        <div class="d-flex flex-row">
                            <div>Sone:</div>
                            <v-spacer></v-spacer>
                            <div>{{snackbar.data.delivery.zone.name}}</div>
                            <!-- <v-chip label :color="snackbar.color" small>{{snackbar.data.delivery.zone.name}}</v-chip> -->
                        </div>
                        <div class="d-flex flex-row">
                            <div>Leverandør:</div>
                            <v-spacer></v-spacer>
                            <div>{{snackbar.data.delivery.supplier ? snackbar.data.delivery.supplier.name : "-"}}</div>
                        </div>
                        <div class="d-flex flex-row">
                            <div>Resursser:</div>
                            <v-spacer></v-spacer>
                            <div>{{getDeliveryResourceNames(snackbar.data)}}</div>
                        </div>
                        <hr>
                        <div class="d-flex flex-row">
                            <div>Eier:</div>
                            <v-spacer></v-spacer>
                            <div>{{snackbar.data.delivery.createdBy.name}}</div>
                        </div>
                        <div class="d-flex flex-row">
                            <div>Bedrift:</div>
                            <v-spacer></v-spacer>
                            <div>{{snackbar.data.delivery.createdBy.company ? snackbar.data.delivery.createdBy.company.name : '-'}}</div>
                        </div>
                    </div>
                </v-card-text>
            </v-card>

        </v-dialog>

        <v-snackbar v-if="!$vuetify.breakpoint.mobile" v-model="snackbar.show" :timeout="snackbar.timeout" :color="snackbar.color" bottom right>
            <div v-if="snackbar.data" style="width: 100%;">
                <div class="d-flex flex-row">
                    <div>Emne:</div>
                    <v-spacer></v-spacer>
                    <div>{{snackbar.data.delivery.name}}</div>
                </div>
                <div class="d-flex flex-row">
                    <div>Sone:</div>
                    <v-spacer></v-spacer>
                    <div>{{snackbar.data.delivery.zone.name}}</div>
                </div>
                <div class="d-flex flex-row">
                    <div>Leverandør:</div>
                    <v-spacer></v-spacer>
                    <div>{{snackbar.data.delivery.supplier ? snackbar.data.delivery.supplier.name : "-"}}</div>
                </div>
                <div class="d-flex flex-row">
                    <div>Resursser:</div>
                    <v-spacer></v-spacer>
                    <div>{{getDeliveryResourceNames(snackbar.data)}}</div>
                </div>
                <hr>
                <div class="d-flex flex-row">
                    <div>Eier:</div>
                    <v-spacer></v-spacer>
                    <div>{{snackbar.data.delivery.createdBy.name}}</div>
                </div>
                <div class="d-flex flex-row">
                    <div>Bedrift:</div>
                    <v-spacer></v-spacer>
                    <div>{{snackbar.data.delivery.createdBy.company ? snackbar.data.delivery.createdBy.company.name : '-'}}</div>
                </div>
            </div>
        </v-snackbar>
    </v-container>
</template>

<script>
import * as axios from "axios";
import * as moment from "moment";
export default {
    data() {
        return {
            date: moment(),
            events: [],
            calendar: {
                // weekdays: [1, 2, 3, 4, 5, 6, 0],
                weekdays: [1, 2, 3, 4, 5],
                weekdayFormat: (info) => {
                    return moment(info.date).format("dd");
                },
                intervalFormat: (info) => {
                    return info.time;
                },
                overlapMode: "stack",
                overlapThreshold: 15,
            },
            snackbar: {
                show: false,
                color: "",
                timeout: -1,
                data: null,
            },
            eventDialog: {
                show: false,
                event: undefined,
            },
            contentFullscreen: false,
            contentShow: false,
            content: {
                name: undefined,
            },
            showSiteplan: false,
        };
    },
    computed: {
        calendarType() {
            return this.$vuetify.breakpoint.smAndDown ? "day" : "week";
        },
        siteplans() {
            return this.$store.getters.filesByType("siteplans");
        },
    },
    methods: {
        previousWeek() {
            if (this.$vuetify.breakpoint.smAndDown) {
                this.$set(this, "date", this.date.clone().subtract(1, "day"));
                return;
            }
            this.$set(this, "date", this.date.clone().subtract(1, "week"));
        },
        today() {
            this.$set(this, "date", moment());
        },
        nextWeek() {
            if (this.$vuetify.breakpoint.smAndDown) {
                this.$set(this, "date", this.date.clone().add(1, "day"));
                return;
            }
            this.$set(this, "date", this.date.clone().add(1, "week"));
        },
        eventMouseEnter(e) {
            this.snackbar.data = e.event;
            this.snackbar.color = e.event.delivery.zone.color;
            this.snackbar.show = true;
        },
        eventMouseLeave() {
            this.snackbar.show = false;
        },
        eventClicked(e) {
            this.eventDialog.event = e.event;
            this.eventDialog.show = true;
            // this.$router.push({ path: `/delivery/details/${e.event.delivery.id}` });
        },
        openEvent() {
            this.$router.push({ path: `/delivery/details/${this.eventDialog.event.delivery.id}` });
        },
        eventColor(event) {
            let color = event.delivery.zone.color;
            return color;
        },
        async downloadDeliveries(startUnix, endUnix) {
            let response = await axios.get(`/delivery`, {
                params: {
                    start: startUnix,
                    end: endUnix,
                },
            });

            return response.data.data;
        },
        convertDeliveriesToEvents(deliveries) {
            return deliveries.map((d) => {
                return {
                    delivery: d,
                    start: moment.unix(d.start).format("YYYY-MM-DD HH:mm"),
                    end: moment.unix(d.end).format("YYYY-MM-DD HH:mm"),
                };
            });
        },
        getDeliveryResourceNames(event) {
            let resources = event?.delivery.resources.filter((r) => r.usage > 0);
            if (resources.length > 0) {
                // return event.delivery.resources.filter(r => r.usage > 0).map(r => r.name).reduce((acc, cur) => { return `${acc},${cur}`});
                return resources
                    .map((r) => `${r.usage}x${r.name}`)
                    .reduce((acc, cur) => {
                        return acc + `, ${cur}`;
                    });
            } else {
                return "-";
            }
        },
        async listSiteplans() {
            let files = await this.$store.dispatch("listFiles", "siteplans");
            files.forEach(async (file) => {
                await this.$store.dispatch("addFile", file);
                if (!this.$store.getters.file(file.name).src) {
                    let { binary, buffer, src, blob, url } = await this.$store.dispatch("downloadFile", file.name);

                    this.$set(file, "binary", binary);
                    this.$set(file, "buffer", buffer);
                    this.$set(file, "src", src);
                    this.$set(file, "blob", blob);
                    this.$set(file, "url", url);
                    await this.$store.dispatch("addFile", file);
                }
            });
        },
    },
    watch: {
        date: {
            async handler() {
                this.events = this.convertDeliveriesToEvents(await this.downloadDeliveries(this.date.clone().startOf("week").unix(), this.date.clone().endOf("week").unix()));
            },
        },
    },
    beforeMount() {
        moment.locale("nb");

        this.events.push({
            delivery: {
                name: "",
                zone: {
                    color: "",
                },
            },
            start: moment().format("YYYY-MM-DD HH:mm"),
            end: moment().format("YYYY-MM-DD HH:mm"),
        });
    },
    async mounted() {
        if (this.$refs.cal) {
            this.$refs.cal.scrollToTime({ hour: 6, minute: 30 });
        }

        this.events = this.convertDeliveriesToEvents(await this.downloadDeliveries(this.date.clone().startOf("week").unix(), this.date.clone().endOf("week").unix()));

        this.listSiteplans();
    },
    beforeRouteEnter(to, from, next) {
        next((vue) => {
            vue.$store.commit("showAppBar", true);
            vue.$store.commit("showNavDrawer", true);
        });
    },
};
</script>

<style lang="scss" scoped>
</style>